export default __webpack_public_path__ + "static/media/P20011.ce90fdc7.png";